import { createSlice } from '@reduxjs/toolkit'

export const kitchenTypologyFilterSlice = createSlice({
  name: 'kitchenTypologyFilter',
  initialState: {
    value: null,
  },
  reducers: {
    setKitchenTypologyFilter: (state,action) => {
      state.value = action.payload
    },
    resetKitchenTypologyFilter: (state) => {
        state.value = null
    }
  },
})

export const { setKitchenTypologyFilter, resetKitchenTypologyFilter } = kitchenTypologyFilterSlice.actions
export default kitchenTypologyFilterSlice.reducer